import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';

import { Trust } from '../models';
import { TrustService } from '../services/trust.service';

/**
 * Resolver for Trust contact routes.
 * Pre-loads trust contact data before navigation completes.
 * 
 * Usage in routing:
 * {
 *   path: 'Trust/:trustId',
 *   resolve: { trust: trustResolver }
 * }
 * 
 * Access in component:
 * this.route.data.subscribe(data => {
 *   const trust = data['trust'];
 * });
 */
export const trustResolver: ResolveFn<Trust.Summary> = (route) => {
  const trustService = inject(TrustService);
  const router = inject(Router);
  const trustId = route.paramMap.get('trustId');

  if (!trustId) {
    router.navigate(['/error'], {
      state: {
        title: 'Invalid Contact',
        message: 'No contact ID provided.',
        backRoute: ['/Contacts'],
        backLabel: 'Back to Contacts'
      }
    });
    return EMPTY;
  }

  return trustService.getSummary(trustId).pipe(
    catchError((error) => {
      router.navigate(['/error'], {
        state: {
          title: 'Contact Not Found',
          message: 'The trust contact could not be loaded. Please try again or contact support if the issue persists.',
          backRoute: ['/Contacts'],
          backLabel: 'Back to Contacts'
        }
      });
      return EMPTY;
    })
  );
};
